import React from 'react';
import Heading from 'src/elements/typography/heading';
import Image from '../../elements/image/image';
import { CarouselElement } from './phone-carousel-styles';
import { PhoneCarouselPhoneIndex } from './PhoneCarousel.landing';

interface PhoneCarouselRotationalViewProps {
  indexedPhonesItems: PhoneCarouselPhoneIndex[];
  carouselWidth: number;
  showAllCaptions?: boolean;
}

const PhoneCarouselRotationalView = ({ indexedPhonesItems, carouselWidth, showAllCaptions }: PhoneCarouselRotationalViewProps): JSX.Element => {
  const translateStep = carouselWidth / (indexedPhonesItems.length - 1);

  return (
    <>
      {indexedPhonesItems.map((phoneItem, index) => {
        return (
          <CarouselElement key={index} style={{
            transform: `translateX(calc(${translateStep * phoneItem.index}px - ${phoneItem.translatePercentOffset}%)) scale(${phoneItem.isEdge ? 0.81 : (phoneItem.isMiddle ? 0.88 : 1)})`,
            // 1, 2, 3 are the z-index levels intended to display a semicircle with overlapping elements, one on top of the other
            zIndex: phoneItem.isEdge ? 1 : (phoneItem.isMiddle ? 2 : 3),
          }}>
            <Image childImageSharp={phoneItem.image.gatsbyImageData} alt={`phone-image-${phoneItem.phoneIndex + 1}`} />
            {
              showAllCaptions && (
                <Heading fontFamily="Lato" text={phoneItem.title} size="1.5em" weight="normal" align="center" />
              )
            }
          </CarouselElement>
        )
      })}
    </>)
}

export default PhoneCarouselRotationalView;
